/* eslint-disable */

const getters = {
  isAuthenticated: state => state.authenticated,
  currentUser: state => state.user,
  currentUserId: (state) => {
    if (state.user) {
      return state.user.uid;
    }
    return null;
  },
  currentUserEmail: state => state.user.email,
  currentUserEmailVerified: state => state.user.emailVerified,
  currentUserPhoneNumber: state => state.user.phoneNumber,
  currentUserDisplayName: state => state.user.displayName,
  currentUserPhotoURL: state => state.user.photoURL,
  currentUserProfile: state => ({
    name: state.user.name,
    uid: state.user.uid,
    email: state.user.email,
    emailVerified: state.user.emailVerified,
    phoneNumber: state.user.phoneNumber,
    displayName: state.user.displayName,
    photoURL: state.user.photoURL,
  }),
  userList: state => state.users,
  apiState: state => state.apiState,
  boToken: state => state.boToken,
};

export default getters;
